module.exports = __webpack_public_path__ + "static/media/AvenirNext600.63840493.woff";